/**
 * SoundResource - defines audio properties and can be referenced by SoundComponent.
 */
import { EngineClass } from '../../systems/ClassRegistry.js';
import { Resource } from '../../utils/ResourceManager.js';
import { property } from '../../utils/serialization/decorator.js';

import type { AudioPath } from '../../utils/serialization/decorator.js';

@EngineClass('SoundResource', { isResource: true })
export class SoundResource extends Resource {
  public override getEditorClassIcon(): string | null {
    return 'Icon_SoundResource';
  }


    @property()
  public name: string = '';

    @property({ required: true, description: 'Audio file path' })
    public audioPath: AudioPath = '';

    @property()
    public volume: number = 1.0;

    @property({ category: 'Spatial' })
    public maxDistance: number = 10000;

    @property({ category: 'Spatial' })
    public distanceModel: 'linear' | 'inverse' | 'exponential' = 'inverse';

    @property({ category: 'Spatial' })
    public rolloffFactor: number = 1.0;
}
